const PlansActionType = {
  STORE_PLAN_DATA: 'PLANS_STORE_DATA',
  SET_CONTRACT_SELECTED: 'PLANS_SET_CONTRACT',
  SWITCH_TO_OPEN_TERM: 'PLANS_SWITCH_TO_OPEN_TERM',
  SET_SELECTED_PLAN: 'PLANS_SET_SELECTED',
  RESET_ALL: 'PLANS_RESET_ALL',
  SET_MOBILE_DISCOUNT: 'SET_MOBILE_DISCOUNT',
  SET_BYOMODEM_SELECTED: 'SET_BYOMODEM_SELECTED',
  SET_IMPORTANTINFO_TICKBOX_SELECTED: 'SET_IMPORTANTINFO_TICKBOX_SELECTED'
};

export default PlansActionType;



/** WEBPACK FOOTER **
 ** ./src/common/PlansActionType.js
 **/